import styled from '@emotion/styled';
import { GridCol, GridRow } from '@naf/grid';
import { breakpoints, spacing } from '@naf/theme';
import { colors } from '@naf-simba/theme';

export const Wrapper = styled.div``;

export const HeaderGridRow = styled(GridRow)`
  position: relative;

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space24};
  }
`;

export const HeaderCol = styled(GridCol)`
  position: relative;
  padding: ${spacing.space40} 0 ${spacing.space40} 0;
  margin: ${spacing.space48} 0;

  h1 {
    margin: 0;
  }

  @media (max-width: ${breakpoints.m}) {
    margin: 0;
    padding: 0;
  }
`;

export const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.space16};
  margin-top: ${spacing.space24};

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space8};
  }
`;

export const ImageCol = styled(GridCol)`
  display: flex;
  justify-content: flex-end;

  img {
    object-fit: contain;
    max-width: 100%;
  }

  @media (max-width: ${breakpoints.m}) {
    order: -1;
  }
`;

export const SpacedGridRow = styled(GridRow)`
  margin-bottom: ${spacing.space48};
`;

export const Body = styled.div`
  margin-bottom: ${spacing.space56};

  p {
    margin: ${spacing.space24} 0;
  }

  h2 + p,
  h2 + ul,
  h2 + table,
  h2 + ol {
    margin-top: 29px;
  }
`;

export const ColoredBox = styled.div`
  position: relative;
  padding-top: 80px;
  padding-bottom: 103px;

  &::before {
    content: '';
    background-color: ${colors.secondary[50]};
    margin-left: -50vw;
    position: absolute;
    width: 150vw;
    height: 100%;
    z-index: -1;
    top: 0;

    @media (max-width: ${breakpoints.m}) {
      width: 100vw;
      margin-left: -25px;
      padding-left: 25px;
      margin-right: -25px;
      padding-right: 25px;
    }
  }
`;

export const QuoteCol = styled(GridCol)`
  display: flex;
  justify-content: center;

  @media (max-width: ${breakpoints.s}) {
    justify-content: flex-start;
  }
`;

export const ReadMoreWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: ${spacing.space48};
  margin-bottom: ${spacing.space40};

  h2 {
    margin: 0;
  }
`;

export const IngressCol = styled(GridCol)`
  @media (min-width: ${breakpoints.m}) {
    p {
      margin: 0;
    }
  }
`;
